import React from "react";
import Meaning from "./Meaning";
import "./Results.css";
import "./Phonetic.css";

export default function Results(props) {
  console.log({props})
  if (props.results) {
    return (
      <div className="Results">
        <section>
          <h2>{props.results.word}</h2>
          <span className="text">{props.results.phonetic}</span>
        </section>
        {props.results.meanings.map(function (meaning, index) {
          return (
            <section key={index}>
              <Meaning meaning={meaning} />
            </section>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
}